import store from '@/states/index.js'

import PlanUploadAdmin from '../PlanUploadAdmin'

export default [
    {
        path: '/plan_upload_admin',
        component: PlanUploadAdmin,
        name: 'plan_upload_admin',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 1){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]